import {
  getObjectFromLocalStorage,
  removeFromLocalStorage,
  setObjectInLocalStorage,
} from "@/common/helpers/localStorage";
import { GoogleSSOSignUpData } from "@/features/Auth/Register/store/GoogleSSOSignUpData";

export class GoogleSSOSignUpDataStore {
  static store(data: GoogleSSOSignUpData) {
    setObjectInLocalStorage?.("googleSSOSignUpData", data);
  }

  static prestoreRedirectionUrl(redirectUrl: string | null | undefined) {
    if (!redirectUrl) {
      return;
    }

    let sanitizedRedirectUrl = redirectUrl;
    try {
      sanitizedRedirectUrl = decodeURIComponent(redirectUrl);
    } catch {
      // If decoding fails we keep the original value so the redirect still works.
      sanitizedRedirectUrl = redirectUrl;
    }

    const existingData = getObjectFromLocalStorage<GoogleSSOSignUpData>?.("googleSSOSignUpData");
    setObjectInLocalStorage?.("googleSSOSignUpData", {
      ...existingData,
      redirectUrl: sanitizedRedirectUrl,
    } as Partial<GoogleSSOSignUpData>);
  }

  static getAndRemove(): GoogleSSOSignUpData | null {
    const data = getObjectFromLocalStorage<GoogleSSOSignUpData>?.("googleSSOSignUpData");
    if (!data) {
      return null;
    }

    removeFromLocalStorage?.("googleSSOSignUpData");
    return data;
  }
}
